import { getApiUrl } from '../../utils/apiConfig';

const getJson = async (path) => {
  const response = await fetch(getApiUrl(path));
  if (response.status === 404) return null;
  if (!response.ok) throw new Error(`news ${response.status}`);
  return response.json();
};

const postJson = async (path, body, token) => {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;
  const response = await fetch(getApiUrl(path), { method: 'POST', headers, body: JSON.stringify(body) });
  const data = await response.json().catch(() => ({}));
  return { status: response.status, ok: response.ok, data };
};

export const fetchDigestList = async (limit = 30) => {
  const data = await getJson(`/api/news/digests?limit=${limit}`);
  return data?.digests || [];
};

export const fetchDigest = (day) => getJson(`/api/news/digests/${encodeURIComponent(day)}`);

export const fetchSubscribeTerms = () => getJson('/api/news/subscribe/terms');

export const requestSubscription = (email, token) => postJson(
  '/api/news/subscribe',
  { email, privacy_consent: true, marketing_consent: true },
  token,
);

export const confirmSubscription = (token) => postJson('/api/news/subscribe/confirm', { token });

export const requestUnsubscribe = (token) => postJson('/api/news/unsubscribe', { token });
